const metresToKilometres = (m) => Math.round(m / 1000);

const kilometresToMetres = (km) => Math.round(km * 1000);

export {
  metresToKilometres,
  kilometresToMetres,
};
